var supportDescriptors = require('core-js/internals/descriptors');
var getBuiltIn = require('core-js/internals/get-built-in');
var defineProperty = require('core-js/internals/object-define-property').f;
var objectCreate = require('core-js/internals/object-create');
var Promise = getBuiltIn('Promise');
var NAME = 'decode';

function decode(){
  return new Promise(function(resolve, reject){
    if(this.complete){
      return resolve();
    }

    this.addEventListener("load", function(){resolve()});

    this.addEventListener("error", function(event){
      // new DOMException(message, name)
      reject(objectCreate(DOMException.prototype, {
        code: {
          value: 0,
        },
        message: {
          value: "The source image cannot be decoded.",//event.error ? event.error.message : event.message,
        },
        name: {
          value: "EncodingError",
        },
      }));
    });
  }.bind(this));
}

if (supportDescriptors) {
  var protos = [HTMLImageElement.prototype, SVGImageElement.prototype];
  for (var i = 0; i < protos.length; i++) {
    var proto = protos[i];

    if (proto.hasOwnProperty(NAME)) {
      continue;
    }

    defineProperty(proto, NAME, {
      configurable: true,
      value: decode,
    });
  }
}
